var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaseBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 17,
    viewBox: "0 0 12 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4848 15.4343V4.81266C11.4848 4.77967 11.4848 4.74607 11.4518 4.71308L7.53476 0.796656C7.50178 0.763672 7.46817 0.763672 7.43519 0.763672H0.962776C0.431919 0.763672 0 1.19495 0 1.72645V15.4013C0 15.9321 0.431282 16.3641 0.962776 16.3641H10.555C10.555 16.3641 11.4848 16.3641 11.4848 15.4343ZM6.77114 1.85901V4.54755C6.77114 5.04542 7.20244 5.47671 7.73392 5.47671H10.4225C10.555 5.47671 10.6216 5.34415 10.522 5.24458L7.00327 1.75943C6.93731 1.65986 6.77114 1.72645 6.77114 1.85901ZM2 13.4859C2 13.087 2.32335 12.7637 2.72223 12.7637H8.77777C9.17665 12.7637 9.5 13.087 9.5 13.4859C9.5 13.8848 9.17665 14.2081 8.77777 14.2081H2.72223C2.32335 14.2081 2 13.8848 2 13.4859ZM2.72223 9.76367C2.32335 9.76367 2 10.087 2 10.4859C2 10.8848 2.32335 11.2081 2.72223 11.2081H5.27777C5.67665 11.2081 6 10.8848 6 10.4859C6 10.087 5.67665 9.76367 5.27777 9.76367H2.72223Z",
    fill: "#2E2E2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaseBlack);
export default __webpack_public_path__ + "static/media/case_black.499455dae33ad0b047285b8a5bfae25c.svg";
export { ForwardRef as ReactComponent };